/*

class to generate userWalkthrough class

{
    "state" : "<code>"
    "userId" : "<string>"
    "pushTokenId" : "<string>"
    "isMuted" : "<boolean>"
    "notifications" : "<timing>"
    "profilePictureURL" : "<string>"
    "profilePictureId" : "<string>"
    "fileType" : "<string>"
}
*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userId: Joi.string().required(),
  isOrgPageV1: Joi.boolean().optional(),
  isDashboardV1: Joi.boolean().optional(),
  isWorkspaceV1: Joi.boolean().optional(),
  isMessageV1: Joi.boolean().optional(),
  isEocsV1: Joi.boolean().optional(),
  isUsersV1: Joi.boolean().optional(),
};

// Define class
class UserWalkthrough extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.userWalkthrough.buildPk(obj.userId),
      identifiers.userWalkthrough.buildSk(obj.state, obj.userId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.UserWalkthrough = UserWalkthrough;
exports.userWalkthroughSchema = schema;